/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'attractive' }, { id: 'attention' }, { id: 'confident' }, { id: 'rightCut' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-improve"
      progress={15}
      field="hairstyleImprove"
      setter="setHairstyleImprove"
      ns="hairstyleImprove"
      imageName="hairstyleImprove"
      options={OPTIONS}
    />
  );
}

export default Page;
